import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=37e0cb70&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=37e0cb70&prod&lang=scss"
import style1 from "./ScrollPane.vue?vue&type=style&index=1&id=37e0cb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0cb70",
  null
  
)

export default component.exports